import RegExp from '@/utils/regExp.js';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isLegal: false,
      idTypeList: [],
      form: {
        assignor: '',
        assignorIdCard: '',
        assignorIdType: '1',
        assignorMobile: ''
      },
      rules: {
        assignor: [
          { required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        assignorIdType: [
          { required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        assignorIdCard: [
          { required: true, message: '请输入证件号', trigger: 'blur'},
          { pattern: RegExp.idCard, message: '请输入正确的证件号', trigger: 'blur'}
        ],
        assignorMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur'},
          { pattern: RegExp.phone, message: '请输入正确的手机号码', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.$store.commit('UPDATE_IS_LEGAL', false);
    // 获取证件类型列表
    this.getIdTypeList();
  },
  computed: {
    ...mapGetters([
      'companyLegalInfo',
      'userType'
    ])
  },
  methods: {
    // 更新被授权人手机号
    updateAssignorMobile() {
      this.$store.commit('UPDATE_ASSIGNOR_MOBILE', this.form.assignorMobile);
    },
    // 当被授权人和法人是同一个人时，同步法人信息
    copyFormData() {
      if (this.isLegal) {
        this.form.assignor = this.companyLegalInfo.legalName;
        this.form.assignorIdCard = this.companyLegalInfo.legalIdCard;
        this.form.assignorMobile = this.companyLegalInfo.legalMobile;
      }
    },
    changeFormData (value) {
      this.$store.commit('UPDATE_IS_LEGAL', value);
      if (value) {
        this.copyFormData();
      } else {
        this.form.assignor = '';
        this.form.assignorIdCard = '';
        this.form.assignorMobile = '';
      }
    },
    // 获取字典：证件类型列表
    getIdTypeList() {
      this.$store.dispatch('getSelectDictList', 'ID_TYPE').then(res => {
        if (res.code === '0') {
          this.idTypeList = res.data;
        }
      });
    },
    validateForm() {
      let isValid = false;
      this.$refs['form'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    }
  }

};
